
import React from 'react';

export const CSSAnimation = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100%',
      gap: '16px'
    }}>
      <div style={{
        background: '#1a1a1a',
        padding: '40px',
        border: '1px solid var(--bw)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '300px',
        height: '400px'
      }}>
        <div className="candle-container">
          <div className="wick"></div>
          <div className="flame-wrapper">
            <div className="flame-shadow"></div>
            <div className="flame flame-1"></div>
            <div className="flame flame-2"></div>
            <div className="flame flame-3"></div>
            <div className="flame-inner"></div>
            <div className="flame-core"></div>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '700' }}>CSS Animation</h3>
        <p style={{ margin: '0', opacity: '0.7', fontSize: '14px', fontFamily: 'Source Code Pro, monospace' }}>
          Layered CSS with realistic color gradients
        </p>
      </div>
      <style jsx>{`
        .candle-container {
          position: relative;
          width: 120px;
          height: 200px;
        }
        
        .wick {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 5px;
          height: 25px;
          background: linear-gradient(to top, #000, #333);
          z-index: 10;
        }
        
        .flame-wrapper {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 140px;
        }
        
        .flame-shadow {
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 70px;
          height: 70px;
          background: radial-gradient(ellipse at center, rgba(255, 100, 0, 0.3), transparent);
          filter: blur(12px);
          animation: shadow-flicker 3s ease-in-out infinite;
        }
        
        .flame {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform-origin: bottom center;
        }
        
        .flame-1 {
          width: 70px;
          height: 100px;
          transform: translateX(-50%);
          background: radial-gradient(ellipse at bottom, 
            rgba(255, 50, 0, 0.8) 0%, 
            rgba(255, 80, 0, 0.6) 20%, 
            rgba(255, 120, 0, 0.4) 40%, 
            transparent 70%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: outer-flame 3s ease-in-out infinite;
          filter: blur(4px);
        }
        
        .flame-2 {
          width: 55px;
          height: 85px;
          transform: translateX(-50%);
          background: radial-gradient(ellipse at bottom, 
            rgba(255, 120, 0, 0.9) 0%, 
            rgba(255, 160, 0, 0.7) 30%, 
            rgba(255, 200, 50, 0.4) 60%, 
            transparent 80%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: middle-flame 2s ease-in-out infinite;
          filter: blur(3px);
        }
        
        .flame-3 {
          width: 45px;
          height: 75px;
          transform: translateX(-50%);
          background: radial-gradient(ellipse at bottom, 
            rgba(255, 180, 50, 0.9) 0%, 
            rgba(255, 220, 100, 0.7) 40%, 
            transparent 70%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: inner-flame-move 1.5s ease-in-out infinite;
          filter: blur(2px);
        }
        
        .flame-inner {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 25px;
          height: 50px;
          background: radial-gradient(ellipse at bottom, 
            rgba(255, 255, 200, 0.9) 0%, 
            rgba(255, 240, 150, 0.7) 30%, 
            rgba(255, 220, 100, 0.4) 60%, 
            transparent 80%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: core-flame 1s ease-in-out infinite;
        }
        
        .flame-core {
          position: absolute;
          bottom: 3px;
          left: 50%;
          transform: translateX(-50%);
          width: 15px;
          height: 25px;
          background: radial-gradient(ellipse at bottom, 
            rgba(180, 200, 255, 0.9) 0%, 
            rgba(255, 255, 240, 0.8) 20%, 
            rgba(255, 255, 200, 0.5) 50%, 
            transparent 70%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: blue-core 0.8s ease-in-out infinite;
        }
        
        @keyframes outer-flame {
          0%, 100% { 
            transform: translateX(-50%) scaleY(1) scaleX(1) rotate(0deg);
            opacity: 0.8;
          }
          25% { 
            transform: translateX(-48%) scaleY(1.15) scaleX(0.95) rotate(-2deg);
            opacity: 0.85;
          }
          50% { 
            transform: translateX(-52%) scaleY(0.95) scaleX(1.05) rotate(1deg);
            opacity: 0.75;
          }
          75% { 
            transform: translateX(-49%) scaleY(1.1) scaleX(0.98) rotate(-1deg);
            opacity: 0.82;
          }
        }
        
        @keyframes middle-flame {
          0%, 100% { 
            transform: translateX(-50%) scaleY(1) scaleX(1) rotate(0deg);
            opacity: 0.9;
          }
          33% { 
            transform: translateX(-48%) scaleY(1.2) scaleX(0.9) rotate(1deg);
            opacity: 0.85;
          }
          66% { 
            transform: translateX(-52%) scaleY(0.9) scaleX(1.1) rotate(-2deg);
            opacity: 0.95;
          }
        }
        
        @keyframes inner-flame-move {
          0%, 100% { 
            transform: translateX(-50%) scaleY(1) scaleX(1);
            opacity: 0.9;
          }
          20% { 
            transform: translateX(-49%) scaleY(1.25) scaleX(0.85);
            opacity: 0.95;
          }
          40% { 
            transform: translateX(-51%) scaleY(0.85) scaleX(1.15);
            opacity: 0.85;
          }
          60% { 
            transform: translateX(-49%) scaleY(1.15) scaleX(0.9);
            opacity: 0.92;
          }
          80% { 
            transform: translateX(-51%) scaleY(0.95) scaleX(1.05);
            opacity: 0.88;
          }
        }
        
        @keyframes core-flame {
          0%, 100% { 
            transform: translateX(-50%) scaleY(1) scaleX(1);
            opacity: 1;
          }
          50% { 
            transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
            opacity: 0.9;
          }
        }
        
        @keyframes blue-core {
          0%, 100% { 
            transform: translateX(-50%) scaleY(1) scaleX(1);
            opacity: 0.9;
          }
          50% { 
            transform: translateX(-50%) scaleY(1.2) scaleX(0.9);
            opacity: 1;
          }
        }
        
        @keyframes shadow-flicker {
          0%, 100% { 
            transform: translateX(-50%) scale(1);
            opacity: 0.3;
          }
          50% { 
            transform: translateX(-50%) scale(1.2);
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

